module.exports = __webpack_public_path__ + "img/6.2b390f08.png";